import React from 'react';
import classNames from 'classnames';

const DetailHowToPlay = ({ text }) =>  {
  return (
    <p className="scene__p">{text}</p>
  );
}

export default DetailHowToPlay;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Detail/DetailHowToPlay.js
 **/